/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import {
  getClosedDataFromApi,
  gotClosedDataFromApi,
  gotClosedDataPartnerFromApi,
  gotErrorFromClosedDataApi,
} from '../../duck/legado/accountingAppV2/closedData';
import { SendLoginTokenAuth } from '../tokens';

export default function getClosedDataV2(
  initialDate: string,
  finalDate: string,
  partner: string
) {
  return (dispatch: any) => {
    dispatch(getClosedDataFromApi());
    cabine
      .get(
        `/v1/legado/relatorio/consolidado/contabil/${partner}/${initialDate}/${finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.data_de_pesquisa = {
          de: initialDate,
          ate: finalDate,
        };
        if (partner === 'terceiros') {
          dispatch(gotClosedDataPartnerFromApi(response.data));
        } else {
          dispatch(gotClosedDataFromApi(response.data));
        }
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromClosedDataApi);
      });
  };
}
